/* eslint-disable */
export default {
  rateExceeded: "Limite richiesta superato. L'app riprenderà tra {ttl} s.",
} as const;

// @key: @#@"rateExceeded"@#@ @source: @#@"Request limit exceeded. App will resume in {ttl} seconds."@#@
